import React from "react";
import {BannerButton, BannerImage, Wrapper} from "./AnnouncementRow.styles";
import {useStore} from "hooks/useStore";
import {ANNOUNCEMENT_BANNER_IMAGE_URL} from "../../customerAnnouncementPopup/announcementConstants";

export const AnnouncementRow = () => {
    const stores = useStore();

    return (
        <Wrapper>
            <BannerButton
                type="button"
                onClick={() => stores.appStore.setAnnouncementPopupVisible(true)}
            >
                <BannerImage src={ANNOUNCEMENT_BANNER_IMAGE_URL} alt="Vigo 7. Yıl Duyurusu" />
            </BannerButton>
        </Wrapper>
    );
};
